@if (!isMobileView) {
  <div class="main-dialog-box">
    <div class="dialog__header mb-34">
      <h2 translate>Add element</h2>
      <app-icon iconName="close" size="20px" (click)="closeDialogBox()" [ngStyle]="{ cursor: 'pointer' }"></app-icon>
    </div>
    <div class="dialog-content-area">
      @for (item of createPopupNavigationItems; track item; let i = $index) {
        @if (hasPermission(item.permissions)) {
          <div class="main-dialog-box__border mt-12" (click)="navigate(item.href)">
            <div class="main-dialog-box__border__content">
              <div class="d-flex justify-content-start align-items-center">
                <div class="main-dialog-box__border__icon-box">
                  <app-icon color="var(--orange)" size="24px" [iconName]="item.icon"></app-icon>
                </div>
                <p class="main-dialog-box__border__element-title ml-20" translate>{{ item.title }}</p>
              </div>
              <div>
                <app-icon iconName="right-arrow" size="24px"></app-icon>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
}

@if (isMobileView) {
  <section class="card-element-wrapper">
    <h2 class="heading-text" translate>Add element</h2>
    <div class="row g-3 mt-24">
      @for (item of createPopupNavigationItems; track item; let i = $index) {
        @if (hasPermission(item.permissions)) {
          <div class="col-6">
            <div class="mobile-card-element" (click)="navigate(item.url)">
              <app-icon color="var(--orange)" iconName="{{ item.icon }}" size="34px"></app-icon>
              <p class="mobile-card-element__text" translate>{{ item.title }}</p>
            </div>
          </div>
        }
      }
    </div>
  </section>
}
